/* file description */
import { useAuth } from '@/components/RuleController/useAuth';
import { RuleTigger, AbilityPoint } from '@/const';
import { message } from 'antd';
import { Utils } from '@/asset/types';
import { notify } from '@/utils';

export const useRowClick = ({
  moduleCode,
  rowClickLink,
  taskId,
  utils,
}: any) => {
  const isAuthorized = useAuth({
    moduleCode,
    ability: AbilityPoint.canView,
  });

  const rowClick = (record, index) => {
    return {
      onClick: (e) => {
        if (!rowClickLink) return;

        if (!isAuthorized) {
          message.warn('无权限查看详情，请联系管理员');
          return;
        }
        if (!taskId) {
          notify.error(notify.Type.TaskIdNotExist);
          return;
        }
        if (!record?._id) {
          notify.error(notify.Type.IdNotExist);
          return;
        }
        utils?.buiNavigate({
          type: 'tab',
          path: `/lcp/task/${taskId}/detail/${record?._id}`,
          title: 'EIMOS',
        });
      },
    };
  };

  return {
    rowClick,
  };
};
